module.exports = __webpack_public_path__ + "static/img/多媒体展示厅.f15d4eb9.png";